var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-9e1309c6-f9f8-4589-a0e0-1ccbec546687",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.33 65.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.12,28.19l-25.55,22.07c-2.23,1.93-5.76,.37-5.76-2.64v-12.76c-22.51,.32-32.22,5.91-25.64,26.96,.73,2.34-2.09,4.15-4.08,2.7C5.75,59.9,0,51.07,0,42.15,0,20.05,18.49,15.37,41.81,15.11V3.49c0-3,3.52-4.57,5.76-2.64l25.55,22.06c1.61,1.39,1.61,3.89,0,5.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkShare);
export default __webpack_public_path__ + "static/media/dark - share.c7f53e317b716dbe6dff600a3ff8d0fb.svg";
export { ForwardRef as ReactComponent };